import { Switch, useRouteMatch } from 'react-router';
import { AdministrationRoute, PrivateRoute } from 'common/AuthRoute';
import React, { memo } from 'react';
import { BusinessPartnerAdminsPage } from 'pages/BusinessPartnerManagement/BusinessPartnerAdminsManagement/BusinessPartnerAdminsPage';
import { BusinessPartnerRegisterAdminPage } from 'pages/BusinessPartnerManagement/BusinessPartnerAdminsManagement/BusinessPartnerRegisterAdminPage';
import { BusinessPartnerAdminsManagementRoutes } from 'pages/BusinessPartnerManagement/BusinessPartnerAdminsManagement/businessPartnerAdminsManagementRoutes';

export const BusinessPartnerAdminsManagement = memo(() => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <PrivateRoute exact path={path} component={BusinessPartnerAdminsPage} />
      <AdministrationRoute
        exact
        path={`${path}/${BusinessPartnerAdminsManagementRoutes.Register}`}
        component={BusinessPartnerRegisterAdminPage}
      />
    </Switch>
  );
});
